
/*
 * @description: 石化运输-货源信息   数据接口
 * @author: zb
 * @update: zb
 * @Date: 2019-05-27 09:29:57
 * @LastEditors: l_hc
 * @LastEditTime: 2019-07-24 14:26:36
 */
import { Page } from '@/utils/commonDataModel'

import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

const prefix = `${LOGISTICE_GATEWAY}/website/personal/goods/cmsGoods/goods`

const webprefix = `${LOGISTICE_GATEWAY}/website/index/personal/goods/cmsGoods/webGoods`

/* 分页获取数据的地址  */
const findList = `${prefix}`

/* 保存数据的地址  */
const saveUrl = `${prefix}`

/* 删除数据的地址  */
const deleteUrl = `${prefix}`

/* 批量删除接口  */
const batchDelUrl = `${prefix}`

/*  获取详情接口  */
const getDetailsUrl = `${prefix}`

/* 获取邀请我报价的货源数据的地址 */
const getMyInvitationUrl = `${prefix}`

/* 收藏接口 */
const conllectionUrl = `${webprefix}/personal/conllection/save`

const cancelConllectionUrl = `${LOGISTICE_GATEWAY}/personal/conllection/delete`

const updateExpectPriceUrl = `${LOGISTICE_GATEWAY}/website/personal/cmsgoodsOffer/saveOffer`

// 邀请接口
const invitationBidUrl = `${LOGISTICE_GATEWAY}/personal/conllection/delete`
// 报价列表接口
const bidListUrl = `${LOGISTICE_GATEWAY}/website/personal/cmsgoodsOffer/findPageList`
// 运力查询自己的所有报价接口
const myBidListUrl = `${LOGISTICE_GATEWAY}/website/personal/goods/cmsGoods/goods`

/* 根据查询参数获取货源数据 */
const getMapListUrl = `${prefix}`

const getwebMapListUrl = `${webprefix}`

/*  批量发布地址 */
const batchIssueUrl = `${prefix}`

/* 货源交易地址 */
const goodsTransactionUrl = `${prefix}`

/* 下架的地址 */
// const revokeUrl = `${prefix}revoke`

/*  下架货源 */
export const revoke = (params) => {
  return logistice.post(batchIssueUrl, Object.assign({ 'methodName': 'batchIssue' }, params))
}

/*  批量发布 */
export const batchIssue = (params) => {
  return logistice.post(batchIssueUrl, Object.assign({ 'methodName': 'batchIssue' }, params))
}

/* 分页查询货源信息 */
export const getPageList = (page, params) => {
  return logistice.post(findList, Object.assign({ 'methodName': 'findPage' }, params, page || new Page()))
}

/* 石化运仓中邀请报价展示的分页查询货源信息 */
export const getInvitationGoodsList = (page, params) => {
  return logistice.post(findList, Object.assign({ 'methodName': 'findInvitationGoods' }, params, page || new Page()))
}

/* 分页查询带有收藏状态的货源信息 */
export const getPageMapList = (page, params) => {
  return logistice.post(findList, Object.assign({ 'methodName': 'findMapList' }, params, page || new Page()))
}

/* 获取详情 */
export const getDetails = (id) => {
  return logistice.post(getDetailsUrl, Object.assign({ id: id }, { 'methodName': 'lookDetails' }))
}

/* 保存数据 */
export const save = (params) => {
  return logistice.post(saveUrl, Object.assign(params, { 'methodName': 'save' }))
}

/* 删除数据 */
export const del = (params) => {
  return logistice.post(deleteUrl, Object.assign(params, { 'methodName': 'del' }))
}

/* 批量删除数据 */
export const batchDel = (params) => {
  return logistice.post(batchDelUrl, Object.assign({ 'methodName': 'batchDel' }, params))
}

/* 收藏货源 */
export const conllection = (params) => {
  return logistice.post(conllectionUrl, Object.assign({ 'methodName': 'saveCollection', 'moduleType': '1' }, params))
}

/* 取消收藏 */
export const cancelConllection = (params) => {
  return logistice.post(cancelConllectionUrl, Object.assign({ 'methodName': 'delCollection' }, params))
}

/* 报价 */
export const updateExpectPrice = (params) => {
  return logistice.post(updateExpectPriceUrl, Object.assign({ 'methodName': 'saveOffer' }, params))
}

export const getMapList = (page, params) => {
  return logistice.post(getMapListUrl, Object.assign({ 'methodName': 'findAllGoods' }, params, page || new Page()))
}
export const getwebMapList = (page, params) => {
  return logistice.post(getwebMapListUrl, Object.assign({ 'methodName': 'findAllGoods' }, params, page || new Page()))
}

// 邀请报价
export const invitationBid = (params) => {
  return logistice.post(invitationBidUrl, Object.assign({ 'methodName': 'delCollection' }, params))
}

// 查看货源的报价列表
export const getBidList = (params) => {
  return logistice.post(bidListUrl, Object.assign({ 'methodName': 'findPageList' }, params))
}

// 运力方查看自己的所有报价货源
export const getMyBidList = (page, params) => {
  return logistice.post(myBidListUrl, Object.assign({ 'methodName': 'findQuotationGoods' }, params, page || new Page()))
}

// 分页查询邀请我报价的货源信息
export const getMyInvitation = (page, params) => {
  return logistice.post(getMyInvitationUrl, Object.assign({ 'methodName': 'findtransportGetGoods' }, page || new Page(), params))
}

// 货源成交
export const goodsTransaction = (params) => {
  return logistice.post(goodsTransactionUrl, Object.assign({ 'methodName': 'batchIssue' }, params))
}
// 平台协议
export function findCmsPlatformProtocol(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + '/website/index/cmsPlatformProtocolManager',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCmsPlatformProtocol'
      }, param))
    }
  })
}
export const goodsListData = [
  {
    'contacter': '1428667993',
    'startPlace': '上海',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:23',
    'goodsImages': 'a.jpg',
    'contacterTel': '152766112345',
    'weight': 17.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '50',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '00b423a59caf4de892e890ca5bb3c8ce',
    'goodsName': '#92汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:26',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:23'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济南',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:21:22',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '0',
    'capacity': '50',
    'companyId': '韵达快递',
    'stopPlace': '东营',
    'goodsLittleType': '2',
    'id': '0a374239c0f84a33970a6bbe08eb2121',
    'goodsName': '#95汽油',
    'remarks': '一车柴油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:29',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:19:49'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:26',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '50',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '0c33544b4ee0402fb608ddb33baf6226',
    'goodsName': '#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:32',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:26'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:16',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '80',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '18c4c480c3b44f12a13b47d7e2a535fb',
    'goodsName': '#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:35',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:16'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:02',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '80',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '1d68560ca50942bd87f22ef9b48790de',
    'goodsName': '-10柴油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:37',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:02'
  }, {
    'startPlace': '["山东省","济宁市"]',
    'physicalProperty': '啦啦啦了',
    'updateDate': '2019-06-13 15:26:04',
    'contacterTel': '010-456789',
    'weight': 8000.0,
    'transportTimeliness': '',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '600',
    'companyId': '1',
    'payType': '支付宝',
    'expectPrice': 90.0,
    'stopPlace': '["山东省","济宁市"]',
    'goodsLittleType': '',
    'sendStatus': '5',
    'id': '3f722e9e92b0455a9af5b00cda9143d8',
    'goodsName': '伊拉克进口石油',
    'remarks': 'this a full data',
    'email': '',
    'startTransportDate': '2019-06-28 00:00:00',
    'favoritesFlag': 0,
    'createDate': '2019-06-13 15:26:04'
  }, {
    'startPlace': '济南',
    'physicalProperty': '测试',
    'updateDate': '2019-06-06 15:11:52',
    'weight': 180000.0,
    'transportTimeliness': '124',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '80',
    'companyId': '顺风快递',
    'stopPlace': '高新',
    'goodsLittleType': '2',
    'id': '428aabffe1404c3a918035c73bd54a7c',
    'goodsName': '-10柴油',
    'favoritesFlag': 0,
    'createDate': '2019-06-06 15:11:52'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:03',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '80',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '573d181e132740de8fa5c362c1956f6c',
    'goodsName': '-10柴油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:40',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:03'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:07',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '80',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '5d25e1d09edb4702bd611859d9be4b58',
    'goodsName': '-10柴油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:44',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:07'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:28',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '80',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '791e8e6a8f14477195653488dbd70285',
    'goodsName': '-10柴油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:47',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:28'
  }, {
    'startPlace': '["山东省","济宁市"]',
    'physicalProperty': '56温度',
    'updateDate': '2019-06-14 10:38:17',
    'contacterTel': '1',
    'weight': 1.0,
    'transportTimeliness': '',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '1',
    'companyId': '',
    'payType': '支付宝',
    'expectPrice': 1.0,
    'stopPlace': '["山东省","济宁市"]',
    'goodsLittleType': '',
    'sendStatus': '5',
    'id': '80038afde5c84cc585752c9f393862b1',
    'goodsName': '哇哈哈',
    'remarks': '11111remarks',
    'email': '',
    'startTransportDate': '2019-06-14 00:00:00',
    'mostLateDeliveryDate': '2019-06-23 00:00:00',
    'favoritesFlag': 0,
    'createDate': '2019-06-14 10:38:17'
  }, {
    'startPlace': '济南',
    'physicalProperty': '222',
    'updateDate': '2019-06-06 14:39:32',
    'weight': 18.0,
    'transportTimeliness': '24',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '韵达快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '862b7268ebba43c7bcacf51e748c2e29',
    'goodsName': '-10柴油',
    'favoritesFlag': 0,
    'createDate': '2019-06-06 14:39:32'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:19:22',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '937bd3726dc648f482efba693ea86a38',
    'goodsName': '-10柴油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:50',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:19:22'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:19:56',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '997dbfc654f94ad39b38f05d5f7ed5f5',
    'goodsName': '-10柴油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:53',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:19:56'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:19:59',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': '99cf85474bef4abe9eae4bb20d0d01b2',
    'goodsName': '#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:29:57',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:19:59'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:05',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': 'a49187d9cb904736a561df4be2284b52',
    'goodsName': '#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:30:01',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:05'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:11',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': 'ba67ef29b5d94ab1bb4bfc5481b7dddc',
    'goodsName': '#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:30:04',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:11'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:13',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '100',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': 'c737b2fe5f834b98af115fd341b5d0a9',
    'goodsName': '#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:30:06',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:13'
  }, {
    'wechatAccount': '1428667993',
    'startPlace': '济宁',
    'physicalProperty': '燃点低',
    'updateDate': '2019-05-31 21:20:30',
    'contacterTel': '152766112345',
    'weight': 12.0,
    'transportTimeliness': '12',
    'delFlag': 0,
    'goodsType': '1',
    'capacity': '500',
    'companyId': '顺风快递',
    'stopPlace': '青岛',
    'goodsLittleType': '2',
    'id': 'd6cb9195e51847a79765a8ee65f76be0',
    'goodsName': '#95汽油\r\n#95汽油',
    'remarks': '一车汽油',
    'email': '1428667993@qq.com',
    'startTransportDate': '2019-05-31 21:30:10',
    'favoritesFlag': 0,
    'createDate': '2019-05-31 21:20:30'
  }, {
    'startPlace': '["山东省","济宁市"]',
    'physicalProperty': '56温度',
    'updateDate': '2019-06-14 10:36:41',
    'contacterTel': '1',
    'weight': 1.0,
    'transportTimeliness': '',
    'delFlag': 0,
    'goodsType': '',
    'capacity': '1',
    'companyId': '',
    'payType': '支付宝',
    'expectPrice': 1.0,
    'stopPlace': '["山东省","济宁市"]',
    'goodsLittleType': '',
    'sendStatus': '5',
    'id': 'dfee627d5d37480694464a33eaf3a743',
    'goodsName': '哇哈哈',
    'remarks': '11111remarks',
    'email': '',
    'startTransportDate': '2019-06-14 00:00:00',
    'mostLateDeliveryDate': '2019-06-23 00:00:00',
    'favoritesFlag': 0,
    'createDate': '2019-06-14 10:36:41'
  }
]

